import styled from 'styled-components';
import React, { useMemo } from 'react';

import { Avatar, AvatarsGroup } from '@/ui/Avatar';
import { RTeamUser } from '@/store/v2';

const BannerStyled = styled.div`
  width: 100%;
  height: 152px;
  padding: 32px;
  border-radius: 4px;
  display: flex;
  gap: 16px;
  flex-direction: column;
  background-color: ${(p) => p.theme.tones.tertiary[95]};
`;

const TitleContainerStyled = styled.div`
  display: flex;
  gap: 12px;
`;

const TitleStyled = styled.p`
  ${({ theme }) => theme.typography.body2};
  color: ${(p) => p.theme.colors.neutral.outline2};
`;

const SubtitleStyled = styled.p`
  color: ${(p) => p.theme.colors.neutral.onBackground};
  ${({ theme }) => theme.typography.body2};
`;

const LIMIT_OF_USERS = 4;

type JourneyAddTeamsModalBannerProps = {
  allUsers: RTeamUser[];
};

export const JourneyAddTeamsModalBanner = ({ allUsers }: JourneyAddTeamsModalBannerProps): React.ReactElement => {
  const usersToRender = useMemo(() => {
    if (!allUsers?.length) return [];

    return allUsers?.slice(0, LIMIT_OF_USERS);
  }, [allUsers]);

  const totalCount = allUsers?.length;

  const usersNames = useMemo(() => {
    const usersNamesList = usersToRender?.map((user) => user?.user?.firstname);

    return usersNamesList?.join(', ');
  }, [usersToRender]);

  return (
    <BannerStyled>
      <TitleContainerStyled>
        {totalCount > 0 && (
          <AvatarsGroup>
            <Avatar image={usersToRender[0]?.user?.profileImage} size="small" outlined />
            {totalCount > 1 && <Avatar image={usersToRender[1]?.user?.profileImage} size="small" outlined />}
            {totalCount > 2 && <Avatar image={usersToRender[2]?.user?.profileImage} size="small" outlined />}
            {totalCount > 3 && <Avatar image={usersToRender[3]?.user?.profileImage} size="small" outlined />}
          </AvatarsGroup>
        )}
        <TitleStyled>{`${usersNames} + ${Number(totalCount) - (usersToRender?.length || 0)} learners added`}</TitleStyled>
      </TitleContainerStyled>
      <SubtitleStyled>
        Team changes are not automatically synchronized here. You will need to re-add the team for new members to be included.
      </SubtitleStyled>
    </BannerStyled>
  );
};
